import { useMemo } from 'react';

function useCombineArrays(...arrays) {
  return useMemo(() => {
    // Filtrar arrays válidos
    const validArrays = arrays.filter((arr) => Array.isArray(arr) && arr.length > 0);

    if (validArrays.length === 0) return []; // Si no hay arrays válidos, retornar vacío

    // Combinar arrays válidos
    const combinedMap = new Map();

    const addOrCombine = (obj) => {
      // const { code } = obj;
      const key = obj.code ?? obj.pk;
      if (!key) return;
      if (combinedMap.has(key)) {
        combinedMap.set(key, {
          ...combinedMap.get(key),
          ...obj
        });
      } else {
        combinedMap.set(key, obj);
      }
    };

    validArrays.forEach((array) => array.forEach(addOrCombine));
    return Array.from(combinedMap.values());
  }, [arrays]); // `useMemo` solo recalcula cuando cambian las referencias de los arrays
}

export default useCombineArrays;
